exports.f = Object.getOwnPropertySymbols;



//////////////////
// WEBPACK FOOTER
// ./node_modules/.2.5.7@core-js/library/modules/_object-gops.js
// module id = 148
// module chunks = 1